// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import {
  addExperienceToFavoritesResponseTransformer,
  getFavoriteExperiencesResponseTransformer,
} from './transformers.gen';
import type {
  AddExperienceToFavoritesData,
  AddExperienceToFavoritesErrors,
  AddExperienceToFavoritesResponses,
  GetCalendarEventsChipsData,
  GetCalendarEventsChipsResponses,
  GetCitiesAroundData,
  GetCitiesAroundResponses,
  GetCitiesInCountryData,
  GetCitiesInCountryResponses,
  GetCitiesRegionData,
  GetCitiesRegionResponses,
  GetCitiesToursByRegionData,
  GetCitiesToursByRegionResponses,
  GetCityInfoBySlugData,
  GetCityInfoBySlugResponses,
  GetCityTagsData,
  GetCityTagsResponses,
  GetCountryFromCitiesInfoData,
  GetCountryFromCitiesInfoResponses,
  GetCountryInfoBySlugData,
  GetCountryInfoBySlugResponses,
  GetCountryTagsData,
  GetCountryTagsResponses,
  GetDisplayCurrenciesData,
  GetDisplayCurrenciesResponses,
  GetExperienceAggregationsData,
  GetExperienceAggregationsResponses,
  GetExperiencesCountData,
  GetExperiencesCountResponses,
  GetExperiencesData,
  GetExperiencesRecommendationsData,
  GetExperiencesRecommendationsResponses,
  GetExperiencesResponses,
  GetFavoriteExperiencesData,
  GetFavoriteExperiencesErrors,
  GetFavoriteExperiencesResponses,
  GetGuidesData,
  GetGuidesResponses,
  GetListingBannersData,
  GetListingBannersResponses,
  GetMovementTypesData,
  GetMovementTypesResponses,
  GetRegionInfoBySlugData,
  GetRegionInfoBySlugResponses,
  GetRegionsInCountryData,
  GetRegionsInCountryResponses,
  GetRegionTagsData,
  GetRegionTagsResponses,
  GetRelatedArticlesByLocationSlugData,
  GetRelatedArticlesByLocationSlugResponses,
  GetRelatedExperiencesData,
  GetRelatedExperiencesResponses,
  GetReviewsData,
  GetReviewsResponses,
  GetSeoByCitySlugData,
  GetSeoByCitySlugResponses,
  GetSeoByCityTagData,
  GetSeoByCityTagResponses,
  GetSeoCountryTagData,
  GetSeoCountryTagResponses,
  GetSeoFromCityToCountryData,
  GetSeoFromCityToCountryResponses,
  GetSeoFromCityToRegionData,
  GetSeoFromCityToRegionResponses,
  GetSeoRegionTagData,
  GetSeoRegionTagResponses,
  GetToursActivitiesData,
  GetToursActivitiesResponses,
  GetTourSeoByIdData,
  GetTourSeoByIdResponses,
  GetUserData,
  GetUserResponses,
  PostChooseTourFormDataData,
  PostChooseTourFormDataErrors,
  PostChooseTourFormDataResponses,
  RemoveExperienceFromFavoritesData,
  RemoveExperienceFromFavoritesErrors,
  RemoveExperienceFromFavoritesResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get user data
 */
export const getUser = <ThrowOnError extends boolean = false>(options?: Options<GetUserData, ThrowOnError>) =>
  (options?.client ?? client).post<GetUserResponses, unknown, ThrowOnError>({ url: '/api/web/v1/me/', ...options });

/**
 * Получить seo информацию по slug города и выбранному тэгу
 */
export const getSeoByCityTag = <ThrowOnError extends boolean = false>(
  options?: Options<GetSeoByCityTagData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSeoByCityTagResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/citytag/',
    ...options,
  });

/**
 * Получить seo информацию по slug города
 */
export const getSeoByCitySlug = <ThrowOnError extends boolean = false>(
  options?: Options<GetSeoByCitySlugData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSeoByCitySlugResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/city/',
    ...options,
  });

/**
 * Получить seo информацию тура
 */
export const getTourSeoById = <ThrowOnError extends boolean = false>(
  options: Options<GetTourSeoByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetTourSeoByIdResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/{tourType}/',
    ...options,
  });

/**
 * Получить seo информацию туров в регион из города
 */
export const getSeoFromCityToRegion = <ThrowOnError extends boolean = false>(
  options?: Options<GetSeoFromCityToRegionData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSeoFromCityToRegionResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/from_city_to_region/',
    ...options,
  });

/**
 * Получить seo информацию туров в регион из города
 */
export const getSeoFromCityToCountry = <ThrowOnError extends boolean = false>(
  options?: Options<GetSeoFromCityToCountryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSeoFromCityToCountryResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/from_city_to_country/',
    ...options,
  });

/**
 * Получить города страны или региона с турами
 */
export const getCitiesInCountry = <ThrowOnError extends boolean = false>(
  options?: Options<GetCitiesInCountryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCitiesInCountryResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/cities/',
    ...options,
  });

/**
 * Получить информацию о городе по slug
 */
export const getCityInfoBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetCityInfoBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCityInfoBySlugResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/cities/{citySlug}/',
    ...options,
  });

/**
 * Получить информацию о регионах по стране
 */
export const getRegionsInCountry = <ThrowOnError extends boolean = false>(
  options: Options<GetRegionsInCountryData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetRegionsInCountryResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/regions/',
    ...options,
  });

/**
 * Получить информацию о регионе по slug
 */
export const getRegionInfoBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetRegionInfoBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetRegionInfoBySlugResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/regions/{regionSlug}/',
    ...options,
  });

/**
 * Получить информацию о стране по slug
 */
export const getCountryInfoBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetCountryInfoBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCountryInfoBySlugResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/countries/{countrySlug}/',
    ...options,
  });

/**
 * Получить информацию о городах, в которые можно поехать из страны
 */
export const getCountryFromCitiesInfo = <ThrowOnError extends boolean = false>(
  options: Options<GetCountryFromCitiesInfoData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCountryFromCitiesInfoResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/countries/{countrySlug}/from_cities/',
    ...options,
  });

/**
 * Получить список гидов
 */
export const getGuides = <ThrowOnError extends boolean = false>(options?: Options<GetGuidesData, ThrowOnError>) =>
  (options?.client ?? client).get<GetGuidesResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/guides/',
    ...options,
  });

/**
 * Получить список отзывов
 */
export const getReviews = <ThrowOnError extends boolean = false>(options?: Options<GetReviewsData, ThrowOnError>) =>
  (options?.client ?? client).get<GetReviewsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/reviews/',
    ...options,
  });

/**
 * Получить список тэгов для региона
 */
export const getRegionTags = <ThrowOnError extends boolean = false>(
  options?: Options<GetRegionTagsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetRegionTagsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/regiontags/',
    ...options,
  });

/**
 * Получить SEO инфу по тегу региона
 */
export const getSeoRegionTag = <ThrowOnError extends boolean = false>(
  options: Options<GetSeoRegionTagData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetSeoRegionTagResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/regiontag/',
    ...options,
  });

/**
 * Получить список тэгов для города
 */
export const getCityTags = <ThrowOnError extends boolean = false>(options?: Options<GetCityTagsData, ThrowOnError>) =>
  (options?.client ?? client).get<GetCityTagsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/citytags/',
    ...options,
  });

/**
 * Получить список тэгов для страны
 */
export const getCountryTags = <ThrowOnError extends boolean = false>(
  options?: Options<GetCountryTagsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCountryTagsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/countrytags/',
    ...options,
  });

/**
 * Получить SEO инфу по тегу страны
 */
export const getSeoCountryTag = <ThrowOnError extends boolean = false>(
  options: Options<GetSeoCountryTagData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetSeoCountryTagResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/countrytag/',
    ...options,
  });

/**
 * Получить полезные статьи
 */
export const getRelatedArticlesByLocationSlug = <ThrowOnError extends boolean = false>(
  options?: Options<GetRelatedArticlesByLocationSlugData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetRelatedArticlesByLocationSlugResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/articles/related/',
    ...options,
  });

/**
 * Get Cities Around
 *
 * Получить список городов вокруг указанного города
 */
export const getCitiesAround = <ThrowOnError extends boolean = false>(
  options: Options<GetCitiesAroundData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCitiesAroundResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/cities/{cityId}/around/',
    ...options,
  });

/**
 * Get Cities Region
 *
 * Получить инфу региона, к которым относится город
 */
export const getCitiesRegion = <ThrowOnError extends boolean = false>(
  options: Options<GetCitiesRegionData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCitiesRegionResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/cities/{citySlug}/banners/',
    ...options,
  });

/**
 * Get Listing Banners
 *
 * Получить баннеры для врезки в листинг
 */
export const getListingBanners = <ThrowOnError extends boolean = false>(
  options?: Options<GetListingBannersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetListingBannersResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/listing_banners/',
    ...options,
  });

/**
 * Post choose tour form data
 *
 * Отправить данные формы обратной связи по турам
 */
export const postChooseTourFormData = <ThrowOnError extends boolean = false>(
  options: Options<PostChooseTourFormDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostChooseTourFormDataResponses, PostChooseTourFormDataErrors, ThrowOnError>({
    url: '/api/web/v1/experience-suggest/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Получить список способов передвижения
 *
 * Получить список типов передвижения, групп типов передвижения и их соответствий
 */
export const getMovementTypes = <ThrowOnError extends boolean = false>(
  options?: Options<GetMovementTypesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMovementTypesResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/movement-types/',
    ...options,
  });

/**
 * Получить список типов активности
 *
 * Получить список типов активности для туров
 */
export const getToursActivities = <ThrowOnError extends boolean = false>(
  options?: Options<GetToursActivitiesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetToursActivitiesResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/tour-activities/',
    ...options,
  });

/**
 * Получить агрегации экспириенсов
 *
 * Получить агрегированные данные для экспириенсов
 */
export const getExperienceAggregations = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperienceAggregationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperienceAggregationsResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/experiences/aggregations/',
    ...options,
  });

/**
 * Получить все экспериены
 */
export const getExperiences = <ThrowOnError extends boolean = false>(
  options: Options<GetExperiencesData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetExperiencesResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/experiences/',
    ...options,
  });

/**
 * Получить все рекоммендованные экспериенсы для пустой и малой выдачи
 */
export const getExperiencesRecommendations = <ThrowOnError extends boolean = false>(
  options: Options<GetExperiencesRecommendationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetExperiencesRecommendationsResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/experiences/empty/',
    ...options,
  });

/**
 * Получить количество экспериенсов по фильтрам
 */
export const getExperiencesCount = <ThrowOnError extends boolean = false>(
  options: Options<GetExperiencesCountData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetExperiencesCountResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/experiences/count/',
    ...options,
  });

/**
 * Получить связанные экспириенсы
 */
export const getRelatedExperiences = <ThrowOnError extends boolean = false>(
  options?: Options<GetRelatedExperiencesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetRelatedExperiencesResponses, unknown, ThrowOnError>({
    url: '/api/web/v2/experiences/related/',
    ...options,
  });

/**
 * Удалить experience из избранного
 */
export const removeExperienceFromFavorites = <ThrowOnError extends boolean = false>(
  options: Options<RemoveExperienceFromFavoritesData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    RemoveExperienceFromFavoritesResponses,
    RemoveExperienceFromFavoritesErrors,
    ThrowOnError
  >({ url: '/api/web/v1/experiences/{id}/favorite/', ...options });

/**
 * Добавить experience в избранное
 */
export const addExperienceToFavorites = <ThrowOnError extends boolean = false>(
  options: Options<AddExperienceToFavoritesData, ThrowOnError>,
) =>
  (options.client ?? client).put<AddExperienceToFavoritesResponses, AddExperienceToFavoritesErrors, ThrowOnError>({
    responseTransformer: addExperienceToFavoritesResponseTransformer,
    url: '/api/web/v1/experiences/{id}/favorite/',
    ...options,
  });

/**
 * Получить список избранных experience
 */
export const getFavoriteExperiences = <ThrowOnError extends boolean = false>(
  options?: Options<GetFavoriteExperiencesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFavoriteExperiencesResponses, GetFavoriteExperiencesErrors, ThrowOnError>({
    responseTransformer: getFavoriteExperiencesResponseTransformer,
    url: '/api/web/v1/experiences/favorites/',
    ...options,
  });

/**
 * Получить seo информацию по турам в городах
 */
export const getCitiesToursByRegion = <ThrowOnError extends boolean = false>(
  options: Options<GetCitiesToursByRegionData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCitiesToursByRegionResponses, unknown, ThrowOnError>({
    url: '/api/seo/v2/category/cities-tours-by-region/{regionSlug}/',
    ...options,
  });

/**
 * Получить интервалы дат для чипсов календаря
 */
export const getCalendarEventsChips = <ThrowOnError extends boolean = false>(
  options?: Options<GetCalendarEventsChipsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCalendarEventsChipsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/calendar-filters',
    ...options,
  });

/**
 * Список валют для переключателя
 *
 * Endpoint доступен без авторизации. Backend возвращает только валюты, доступные для переключателя и имеющие валидный курс.
 */
export const getDisplayCurrencies = <ThrowOnError extends boolean = false>(
  options?: Options<GetDisplayCurrenciesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDisplayCurrenciesResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/multicurrency/display_currencies/',
    ...options,
  });
